import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Axios instance
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Tüm isteklere token ekleme
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;

// ============================
// KULLANICI HELPER'LARI - userType sistemi
// ============================

export const getCurrentUser = () => {
    try {
        const userStr = localStorage.getItem('user');
        return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
        return null;
    }
};

export const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    const user = getCurrentUser();
    return !!(token && user);
};

export const isAdmin = () => {
    const user = getCurrentUser();
    return user?.userType === 'admin';
};

export const isRepresentative = () => {
    const user = getCurrentUser();
    return user?.userType === 'representative' || user?.userType === 'admin';
};

export const isDealer = () => {
    const user = getCurrentUser();
    return user?.userType === 'dealer' || user?.userType === 'admin';
};

export const isIndividual = () => {
    const user = getCurrentUser();
    return user?.userType === 'individual';
};

// Araç işlemleri için yetki kontrolü
export const canManageVehicles = () => {
    const user = getCurrentUser();
    return user?.userType === 'representative' || user?.userType === 'admin';
};

// Error handler
export const handleApiError = (error, showToast = true) => {
    console.error('API Error:', error);

    let message = 'Bir hata oluştu';
    if (error.response?.data?.message) {
        message = error.response.data.message;
    } else if (error.message) {
        message = error.message;
    }

    if (showToast && window.toast) {
        window.toast.error(message);
    }

    // 401 = token süresi dolmuş
    if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
    }

    return message;
};

// ============================
// YENİ: aylik financial  FONKSİYONLARI
// ============================

export const getMonthlyFinancialAnalytics = async (filters = {}) => {
    try {
        const response = await api.get('/analytics/monthly-financial', { params: filters });

        const { monthlyFinancial } = response.data.data;

        const purchaseVsSales = monthlyFinancial.map(item => ({
            month: item.monthName,
            purchases: item.totalPurchaseCost,
            sales: item.totalSalesRevenue
        }));

        return {
            success: true,
            data: {
                purchaseVsSales
            }
        };
    } catch (error) {
        console.error('Monthly financial analytics error:', error);
        throw error;
    }
};

export const getMonthlyQuantityAnalytics = async (filters = {}) => {
    try {
        const response = await api.get('/analytics/monthly-quantity', { params: filters });

        const { monthlyQuantity } = response.data.data;

        const purchaseVsSalesCount = monthlyQuantity.map(item => ({
            month: item.monthName,
            purchaseCount: item.purchasedCount,
            salesCount: item.soldCount
        }));

        return {
            success: true,
            data: {
                purchaseVsSalesCount
            }
        };
    } catch (error) {
        console.error('Monthly quantity analytics error:', error);
        throw error;
    }
};

export const getMonthlySalesTypesAnalytics = async (filters = {}) => {
    try {
        const response = await api.get('/analytics/monthly-sales-types', { params: filters });

        const { monthlySalesData } = response.data.data;

        return {
            success: true,
            data: {
                monthlySalesData
            }
        };
    } catch (error) {
        console.error('Monthly sales types analytics error:', error);
        throw error;
    }
};

export const exportAnalyticsToPDF = async (filters, analyticsData) => {
    try {
        const response = await api.post('/analytics/export-pdf', {
            filters,
            data: analyticsData
        }, {
            responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `admin-analytics-${new Date().toISOString().split('T')[0]}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return { success: true };
    } catch (error) {
        console.error('PDF export error:', error);
        throw error;
    }
};

export const exportAnalyticsToExcel = async (filters, analyticsData) => {
    try {
        const response = await api.post('/analytics/export-excel', {
            filters,
            data: analyticsData
        }, {
            responseType: 'blob'
        });

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `admin-analytics-${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return { success: true };
    } catch (error) {
        console.error('Excel export error:', error);
        throw error;
    }
};

// Brand Trends Analysis
export const getBrandTrendsAnalysis = async (filters = {}) => {
    try {
        const response = await api.get('/vehicles/analytics/brand-trends', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getBrandTrendsAnalysis error:', error);
        throw error;
    }
};

// Monthly Application List (düzeltilmiş status'larla)
export const getMonthlyApplicationListFixed = async (filters = {}) => {
    try {
        const response = await api.get('/vehicles/analytics/monthly-applications', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getMonthlyApplicationListFixed error:', error);
        throw error;
    }
};

// ============================
// INSTAGRAM FONKSİYONLARI
// ============================
export const getInstagramReels = async (limit = 8) => {
    try {
        const response = await api.get(`/instagram/reels?limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error('Instagram reels fetch error:', error);
        return {
            success: false,
            error: 'Instagram reels alınamadı',
            data: []
        };
    }
};

export const getInstagramAccount = async () => {
    try {
        const response = await api.get('/instagram/account');
        return response.data;
    } catch (error) {
        console.error('Instagram account fetch error:', error);
        return {
            success: false,
            error: 'Instagram hesap bilgileri alınamadı',
            data: null
        };
    }
};

// ============================
// VEHICLE FONKSİYONLARI - Basit wrapper'lar
// ============================
export const getVehicles = async (filters = {}) => {
    try {
        const response = await api.get('/vehicles', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getVehicles error:', error);
        throw error;
    }
};

export const getVehicleById = async (id) => {
    try {
        const response = await api.get(`/vehicles/${id}`);
        return response.data;
    } catch (error) {
        console.error('getVehicleById error:', error);
        throw error;
    }
};

export const getSalesAnalytics = async (filters = {}) => {
    try {
        const response = await api.get('/vehicles/analytics/sales', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getSalesAnalytics error:', error);
        throw error;
    }
};

// ============================
// YENİ ERP FONKSİYONLARI - Frontend'te import edilen eksik fonksiyonlar
// ============================

// Araç durumu güncelle (sat/rezerve)
export const updateVehicleStatus = async (vehicleId, statusData) => {
    try {
        const response = await api.put(`/vehicles/${vehicleId}/status`, statusData);
        return response.data;
    } catch (error) {
        console.error('updateVehicleStatus error:', error);
        throw error;
    }
};

// Masraf ekle
export const addExpense = async (vehicleId, expenseData) => {
    try {
        const response = await api.post(`/vehicles/${vehicleId}/expenses`, expenseData);
        return response.data;
    } catch (error) {
        console.error('addExpense error:', error);
        throw error;
    }
};

// Hızlı arama (plaka/şase/motor)
export const searchByIdentifier = async (identifier) => {
    try {
        const response = await api.get(`/vehicles/search/${identifier}`);
        return response.data;
    } catch (error) {
        console.error('searchByIdentifier error:', error);
        throw error;
    }
};

// ============================
// YENİ ANALYTICS API FUNCTIONS - STEP 4
// MODAL DETAYLARI İÇİN API CALLS
// ============================

// VEHICLE ANALYTICS
export const getDetailedVehicleList = async (filters = {}) => {
    try {
        const response = await api.get('/vehicles/analytics/detailed-list', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getDetailedVehicleList error:', error);
        throw error;
    }
};

export const getContractStatusAnalysis = async (filters = {}) => {
    try {
        const response = await api.get('/vehicles/analytics/contract-status', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getContractStatusAnalysis error:', error);
        throw error;
    }
};

export const getTopProfitableSales = async (filters = {}) => {
    try {
        const response = await api.get('/vehicles/analytics/top-profitable-sales', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getTopProfitableSales error:', error);
        throw error;
    }
};

// APPLICATION ANALYTICS
export const getMonthlyApplicationList = async (filters = {}) => {
    try {
        const response = await api.get('/applications/analytics/monthly-list', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getMonthlyApplicationList error:', error);
        throw error;
    }
};

export const getDealerApplicationPerformance = async (filters = {}) => {
    try {
        const response = await api.get('/applications/analytics/dealer-performance', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getDealerApplicationPerformance error:', error);
        throw error;
    }
};

export const getApplicationStatusDetails = async (filters = {}) => {
    try {
        const response = await api.get('/applications/analytics/status-details', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getApplicationStatusDetails error:', error);
        throw error;
    }
};

// USER/REPRESENTATIVE ANALYTICS
export const getRepresentativeVehicleDetails = async (userId, filters = {}) => {
    try {
        const response = await api.get(`/users/analytics/representative-vehicles/${userId}`, { params: filters });
        return response.data;
    } catch (error) {
        console.error('getRepresentativeVehicleDetails error:', error);
        throw error;
    }
};

export const getRepresentativeActivityDetails = async (filters = {}) => {
    try {
        const response = await api.get('/users/analytics/representative-activity', { params: filters });
        return response.data;
    } catch (error) {
        console.error('getRepresentativeActivityDetails error:', error);
        throw error;
    }
};

// ============================
// MODAL DATA HELPER FUNCTIONS
// ============================

// Modal için uygun veri formatına çeviren helper - UPDATED
// Modal için uygun veri formatına çeviren helper - UPDATED to use new backend endpoint
export const getModalData = async (modalType, filters = {}) => {
    try {
        console.log(`🔍 Fetching modal data for: ${modalType}`);

        // Yeni backend endpoint'ini kullan
        const queryParams = new URLSearchParams({
            type: modalType,
            ...(filters.days && { days: filters.days }),
            ...(filters.startDate && { startDate: filters.startDate }),
            ...(filters.endDate && { endDate: filters.endDate })
        });

        const response = await api.get(`/analytics/modal-data?${queryParams}`);

        console.log(`✅ Modal data fetched for ${modalType}:`, response.data);
        return response.data;

    } catch (error) {
        console.error(`❌ getModalData error for ${modalType}:`, error);
        throw error;
    }
};

// Detaylı analiz raporları için yardımcı fonksiyon
export const generateDetailedReport = async (reportType, filters = {}) => {
    try {
        console.log(`📊 Generating detailed report: ${reportType}`);

        const reportData = {};

        switch (reportType) {
            case 'comprehensive':
                // Kapsamlı analiz raporu
                const [vehicles, applications, representatives] = await Promise.all([
                    getDetailedVehicleList({ type: 'all', ...filters }),
                    getApplicationStatusDetails({ status: 'all', ...filters }),
                    getRepresentativeActivityDetails({ activityLevel: 'all', ...filters })
                ]);

                reportData.vehicles = vehicles;
                reportData.applications = applications;
                reportData.representatives = representatives;
                break;

            case 'sales':
                // Satış odaklı rapor
                const [soldVehicles, contractAnalysis, profitableSales] = await Promise.all([
                    getDetailedVehicleList({ type: 'sold', ...filters }),
                    getContractStatusAnalysis(filters),
                    getTopProfitableSales({ limit: 100, ...filters })
                ]);

                reportData.soldVehicles = soldVehicles;
                reportData.contractAnalysis = contractAnalysis;
                reportData.profitableSales = profitableSales;
                break;

            case 'representatives':
                // Temsilci odaklı rapor
                const representativeData = await getRepresentativeActivityDetails({
                    activityLevel: 'all',
                    limit: 100,
                    ...filters
                });

                reportData.representatives = representativeData;
                break;

            case 'applications':
                // Başvuru odaklı rapor
                const [monthlyApps, dealerPerf, statusDetails] = await Promise.all([
                    getMonthlyApplicationList({ status: 'all', ...filters }),
                    getDealerApplicationPerformance(filters),
                    getApplicationStatusDetails({ status: 'all', ...filters })
                ]);

                reportData.monthlyApplications = monthlyApps;
                reportData.dealerPerformance = dealerPerf;
                reportData.statusDetails = statusDetails;
                break;

            default:
                throw new Error(`Unknown report type: ${reportType}`);
        }

        return {
            success: true,
            reportType,
            data: reportData,
            generatedAt: new Date(),
            filters
        };

    } catch (error) {
        console.error(`generateDetailedReport error for ${reportType}:`, error);
        throw error;
    }
};

// ============================
// EXPORT HELPER FUNCTIONS
// ============================

// CSV export için veri formatı
export const formatDataForCSV = (data, type) => {
    try {
        switch (type) {
            case 'vehicles':
                return data.vehicles?.map(v => ({
                    'Plaka': v.vehicleInfo?.plateNumber || v.plateNumber,
                    'Marka': v.vehicleInfo?.brand || v.brand,
                    'Model': v.vehicleInfo?.model || v.model,
                    'Yıl': v.vehicleInfo?.year || v.year,
                    'Alış Fiyatı': v.financial?.purchasePrice || v.purchasePrice,
                    'Satış Fiyatı': v.financial?.salePrice || v.salePrice,
                    'Net Kar': v.financial?.netProfit || 0,
                    'Kar Marjı (%)': v.financial?.profitMargin || 0,
                    'Durum': v.status?.current || v.status,
                    'Satış Tarihi': v.status?.soldDate || v.soldDate || '-'
                })) || [];

            case 'applications':
                return data.applications?.map(a => ({
                    'Müşteri': a.customerInfo?.name || a.customer?.name,
                    'TC No': a.customerInfo?.tcNumber || a.customer?.tcNumber,
                    'Telefon': a.customerInfo?.phone || a.customer?.phone,
                    'Gelir': a.financialInfo?.income || a.financial?.income,
                    'Araç Tutarı': a.financialInfo?.vehicleAmount || a.financial?.vehicleAmount,
                    'Aylık Ödeme': a.financialInfo?.monthlyPayment || a.financial?.monthlyPayment,
                    'Vade': a.financialInfo?.term || a.financial?.term,
                    'Durum': a.applicationInfo?.status || a.application?.status,
                    'Kaynak': a.applicationInfo?.source || a.application?.source,
                    'Başvuru Tarihi': a.applicationInfo?.createdAt || a.application?.createdAt
                })) || [];

            case 'representatives':
                return data.representatives?.map(r => ({
                    'Temsilci': r.representative?.name,
                    'Galeri': r.representative?.dealerName || '-',
                    'Toplam Araç': r.vehicleActivity?.totalVehicles || 0,
                    'Satılan Araç': r.vehicleActivity?.soldVehicles || 0,
                    'Toplam Satış': r.vehicleActivity?.totalSales || 0,
                    'Net Kar': r.vehicleActivity?.totalProfit || 0,
                    'Satış Oranı (%)': r.vehicleActivity?.salesRate || 0,
                    'Başvuru Sayısı': r.applicationActivity?.totalApplications || 0,
                    'Aktivite Durumu': r.activityProfile?.status || 'Bilinmiyor',
                    'Son Aktivite (Gün)': r.activityProfile?.lastActivity || '-'
                })) || [];

            default:
                console.warn(`Unknown CSV format type: ${type}`);
                return [];
        }
    } catch (error) {
        console.error(`formatDataForCSV error for ${type}:`, error);
        return [];
    }
};

// Download CSV helper
export const downloadCSV = (data, filename) => {
    try {
        if (!data || data.length === 0) {
            console.warn('No data to export');
            return;
        }

        const headers = Object.keys(data[0]);
        const csvContent = [
            headers.join(','),
            ...data.map(row =>
                headers.map(header =>
                    `"${(row[header] || '').toString().replace(/"/g, '""')}"`
                ).join(',')
            )
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `${filename}-${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log(`✅ CSV downloaded: ${filename}`);
    } catch (error) {
        console.error('downloadCSV error:', error);
        throw error;
    }
};

// ============================
// ✅ DOCUMENT FUNCTIONS - CLEANED & SIMPLIFIED
// ============================

// ✅ CORE UPLOAD FUNCTIONS - KEPT
export const uploadDocument = async (formData) => {
    try {
        const response = await api.post('/documents/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Upload document error:', error);
        throw error;
    }
};

export const bulkUploadDocuments = async (formData) => {
    try {
        const response = await api.post('/documents/bulk-upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Bulk upload documents error:', error);
        throw error;
    }
};

export const bulkUploadByCategory = async (formData) => {
    try {
        const response = await api.post('/documents/bulk-upload-category', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Bulk upload by category error:', error);
        throw error;
    }
};

// ✅ VIEW/GET FUNCTIONS - KEPT
export const getDocumentById = async (documentId) => {
    try {
        const response = await api.get(`/documents/${documentId}`);
        return response.data;
    } catch (error) {
        console.error('Get document by ID error:', error);
        throw error;
    }
};

export const getVehicleDocuments = async (vehicleId, params = {}) => {
    try {
        const response = await api.get(`/documents/vehicle/${vehicleId}`, { params });
        return response.data;
    } catch (error) {
        console.error('Get vehicle documents error:', error);
        throw error;
    }
};

// ✅ SADECE SÖZLEŞME DETAYLARINDA KULLANILACAK
export const getCustomerDocuments = async (customerId, params = {}) => {
    try {
        const response = await api.get(`/documents/customer/${customerId}`, { params });
        return response.data;
    } catch (error) {
        console.error('Get customer documents error:', error);
        throw error;
    }
};

export const getReportDocuments = async (reportId) => {
    try {
        const response = await api.get(`/documents/report/${reportId}`);
        return response.data;
    } catch (error) {
        console.error('Get report documents error:', error);
        throw error;
    }
};

export const getDocumentCategories = async () => {
    try {
        const response = await api.get('/documents/categories');
        return response.data;
    } catch (error) {
        console.error('Get document categories error:', error);
        throw error;
    }
};

// ⚠️ UPDATE/DELETE - SADECE İŞLEM ESNASINDA (SESSION BAZLI)
export const updateDocument = async (documentId, updateData) => {
    try {
        const response = await api.put(`/documents/${documentId}`, updateData);
        return response.data;
    } catch (error) {
        console.error('Update document error:', error);
        throw error;
    }
};

export const deleteDocument = async (documentId) => {
    try {
        const response = await api.delete(`/documents/${documentId}`);
        return response.data;
    } catch (error) {
        console.error('Delete document error:', error);
        throw error;
    }
};

export const downloadDocument = async (documentId) => {
    try {
        // Bu endpoint redirect yapıyor, doğrudan URL'e gidecek
        window.open(`${api.defaults.baseURL}/documents/${documentId}/download`, '_blank');
        return { success: true };
    } catch (error) {
        console.error('Download document error:', error);
        throw error;
    }
};

// ============================
// ✅ DOCUMENT HELPER FUNCTIONS
// ============================

export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const getDocumentTypeColor = (category) => {
    const colorMap = {
        'nufus_cuzdani': 'primary',
        'ehliyet': 'success',
        'gelir_belgesi': 'warning',
        'findex_raporu': 'info',
        'ikametgah_belgesi': 'secondary',
        'banka_hesap_belgesi': 'success',
        'maas_bordrosu': 'warning',
        'vergi_levhasi': 'info',
        'sgk_belgesi': 'primary',
        // Vehicle categories
        'ruhsat': 'danger',
        'alis_sozlesmesi': 'success',
        'satis_sozlesmesi': 'warning',
        'trafik_sigortasi': 'info',
        'diger': 'secondary'
    };
    return colorMap[category] || 'secondary';
};

export const getCategoryDisplayName = (category) => {
    const categoryNames = {
        'nufus_cuzdani': 'Nüfus Cüzdanı',
        'ehliyet': 'Ehliyet',
        'gelir_belgesi': 'Gelir Belgesi',
        'findex_raporu': 'Findex Raporu',
        'ikametgah_belgesi': 'İkametgah Belgesi',
        'banka_hesap_belgesi': 'Banka Hesap Belgesi',
        'maas_bordrosu': 'Maaş Bordrosu',
        'vergi_levhasi': 'Vergi Levhası',
        'sgk_belgesi': 'SGK Belgesi',
        // Vehicle categories
        'ruhsat': 'Ruhsat',
        'alis_sozlesmesi': 'Alış Sözleşmesi',
        'satis_sozlesmesi': 'Satış Sözleşmesi',
        'trafik_sigortasi': 'Trafik Sigortası',
        'diger': 'Diğer'
    };
    return categoryNames[category] || category;
};

export const getStatusDisplayName = (status) => {
    const statusNames = {
        'active': 'Aktif',
        'archived': 'Arşivlenmiş'
    };
    return statusNames[status] || status;
};

export const getStatusColor = (status) => {
    const statusColors = {
        'active': 'success',
        'archived': 'secondary'
    };
    return statusColors[status] || 'secondary';
};

// ✅ NEW: Masraf sil - LEAN ADDITION
export const deleteExpense = async (expenseId) => {
    try {
        const response = await api.delete(`/expenses/${expenseId}`);
        return response.data;
    } catch (error) {
        console.error('deleteExpense error:', error);
        throw error;
    }
};

// ============================
// 🆕 EMPLOYEE API FUNCTIONS
// ============================

// Basic CRUD Operations
export const getEmployees = async (params = {}) => {
    try {
        const response = await api.get('/employees', { params });
        return response.data;
    } catch (error) {
        console.error('getEmployees error:', error);
        throw error;
    }
};

export const getEmployeeById = async (id) => {
    try {
        const response = await api.get(`/employees/${id}`);
        return response.data;
    } catch (error) {
        console.error('getEmployeeById error:', error);
        throw error;
    }
};

export const createEmployee = async (employeeData) => {
    try {
        const response = await api.post('/employees', employeeData);
        return response.data;
    } catch (error) {
        console.error('createEmployee error:', error);
        throw error;
    }
};

export const updateEmployee = async (id, employeeData) => {
    try {
        const response = await api.put(`/employees/${id}`, employeeData);
        return response.data;
    } catch (error) {
        console.error('updateEmployee error:', error);
        throw error;
    }
};

export const deleteEmployee = async (id) => {
    try {
        const response = await api.delete(`/employees/${id}`);
        return response.data;
    } catch (error) {
        console.error('deleteEmployee error:', error);
        throw error;
    }
};

export const searchEmployees = async (query, limit = 10) => {
    try {
        const response = await api.get('/employees/search', {
            params: { q: query, limit }
        });
        return response.data;
    } catch (error) {
        console.error('searchEmployees error:', error);
        throw error;
    }
};

// Document Management
export const uploadEmployeeDocument = async (employeeId, formData) => {
    try {
        const response = await api.post(`/employees/${employeeId}/documents`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('uploadEmployeeDocument error:', error);
        throw error;
    }
};

export const getEmployeeDocuments = async (employeeId) => {
    try {
        const response = await api.get(`/employees/${employeeId}/documents`);
        return response.data;
    } catch (error) {
        console.error('getEmployeeDocuments error:', error);
        throw error;
    }
};

export const deleteEmployeeDocument = async (employeeId, documentId, documentType) => {
    try {
        const response = await api.delete(`/employees/${employeeId}/documents/${documentId}`, {
            params: { documentType }
        });
        return response.data;
    } catch (error) {
        console.error('deleteEmployeeDocument error:', error);
        throw error;
    }
};

// Leave Management
export const createLeaveRequest = async (employeeId, leaveData) => {
    try {
        const response = await api.post(`/employees/${employeeId}/leave-requests`, leaveData);
        return response.data;
    } catch (error) {
        console.error('createLeaveRequest error:', error);
        throw error;
    }
};

export const updateLeaveRequest = async (employeeId, leaveId, updateData) => {
    try {
        const response = await api.put(`/employees/${employeeId}/leave-requests/${leaveId}`, updateData);
        return response.data;
    } catch (error) {
        console.error('updateLeaveRequest error:', error);
        throw error;
    }
};

export const getEmployeeLeaveRequests = async (employeeId) => {
    try {
        const response = await api.get(`/employees/${employeeId}/leave-requests`);
        return response.data;
    } catch (error) {
        console.error('getEmployeeLeaveRequests error:', error);
        throw error;
    }
};

// Contract Management
export const renewEmployeeContract = async (employeeId, contractData) => {
    try {
        const response = await api.post(`/employees/${employeeId}/renew-contract`, contractData);
        return response.data;
    } catch (error) {
        console.error('renewEmployeeContract error:', error);
        throw error;
    }
};

export const getContractExpiringEmployees = async (days = 30) => {
    try {
        const response = await api.get('/employees/contract-expiring', {
            params: { days }
        });
        return response.data;
    } catch (error) {
        console.error('getContractExpiringEmployees error:', error);
        throw error;
    }
};

// Reports & Analytics
export const getEmployeeDashboardStats = async () => {
    try {
        const response = await api.get('/employees/analytics/dashboard-stats');
        return response.data;
    } catch (error) {
        console.error('getEmployeeDashboardStats error:', error);
        throw error;
    }
};

export const generateEmployeeMonthlyReport = async (employeeId, month, year) => {
    try {
        const response = await api.get(`/employees/${employeeId}/reports/monthly`, {
            params: { month, year }
        });
        return response.data;
    } catch (error) {
        console.error('generateEmployeeMonthlyReport error:', error);
        throw error;
    }
};

export const getEmployeeReport = async (employeeId) => {
    try {
        const response = await api.get(`/employees/${employeeId}/report`);
        return response.data;
    } catch (error) {
        console.error('getEmployeeReport error:', error);
        throw error;
    }
};

// Helper Functions
export const formatEmployeeData = (employee) => {
    return {
        id: employee._id,
        fullName: employee.personalInfo?.fullName,
        tcNo: employee.personalInfo?.tcNo,
        phone: employee.personalInfo?.phone,
        email: employee.personalInfo?.email,
        position: employee.workInfo?.position,
        department: employee.workInfo?.department,
        workStatus: employee.workInfo?.workStatus,
        contractType: employee.workInfo?.contractType,
        startDate: employee.workInfo?.startDate,
        contractEndDate: employee.workInfo?.contractEndDate,
        age: employee.age,
        workDuration: employee.workDuration
    };
};

export const getEmployeeStatusColor = (status) => {
    const statusColors = {
        'aktif': 'success',
        'izinli': 'warning',
        'ayrılmış': 'secondary',
        'sözleşme_bitmiş': 'danger'
    };
    return statusColors[status] || 'secondary';
};

export const getEmployeeStatusDisplayName = (status) => {
    const statusNames = {
        'aktif': 'Aktif',
        'izinli': 'İzinli',
        'ayrılmış': 'Ayrılmış',
        'sözleşme_bitmiş': 'Sözleşme Bitmiş'
    };
    return statusNames[status] || status;
};

export const getContractTypeDisplayName = (contractType) => {
    const contractNames = {
        'belirsiz_sureli': 'Belirsiz Süreli',
        'belirli_sureli': 'Belirli Süreli',
        'deneme_sureli': 'Deneme Süreli'
    };
    return contractNames[contractType] || contractType;
};

export const getDepartmentDisplayName = (department) => {
    const departmentNames = {
        'satış': 'Satış',
        'muhasebe': 'Muhasebe',
        'insan_kaynakları': 'İnsan Kaynakları',
        'bilgi_işlem': 'Bilgi İşlem',
        'genel_koordinatör': 'Genel Koordinatör',
        'temizlik': 'Temizlik',
        'güvenlik': 'Güvenlik',
        'diğer': 'Diğer'
    };
    return departmentNames[department] || department;
};

export const getLeaveTypeDisplayName = (leaveType) => {
    const leaveNames = {
        'yıllık': 'Yıllık İzin',
        'hastalık': 'Hastalık İzni',
        'mazeret': 'Mazeret İzni',
        'babalık': 'Babalık İzni',
        'doğum': 'Doğum İzni',
        'diğer': 'Diğer'
    };
    return leaveNames[leaveType] || leaveType;
};

export const calculateWorkDuration = (startDate) => {
    if (!startDate) return 'Bilinmiyor';

    const start = new Date(startDate);
    const today = new Date();
    const diffTime = Math.abs(today - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const years = Math.floor(diffDays / 365);
    const months = Math.floor((diffDays % 365) / 30);

    if (years > 0) {
        return `${years} yıl ${months} ay`;
    } else if (months > 0) {
        return `${months} ay`;
    } else {
        return `${diffDays} gün`;
    }
};

export const calculateAge = (birthDate) => {
    if (!birthDate) return null;

    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
    }

    return age;
};

export const formatTurkishDate = (date) => {
    if (!date) return '-';

    return new Date(date).toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

export const formatCurrency = (amount) => {
    if (!amount) return '0 ₺';

    return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
    }).format(amount);
};

// Download Employee Data as CSV
export const downloadEmployeeCSV = (employees, filename = 'personel-listesi') => {
    try {
        const csvData = employees.map(emp => ({
            'Ad Soyad': emp.personalInfo?.fullName || '',
            'TC Kimlik': emp.personalInfo?.tcNo || '',
            'Telefon': emp.personalInfo?.phone || '',
            'Email': emp.personalInfo?.email || '',
            'Pozisyon': emp.workInfo?.position || '',
            'Departman': getDepartmentDisplayName(emp.workInfo?.department) || '',
            'Sözleşme Türü': getContractTypeDisplayName(emp.workInfo?.contractType) || '',
            'İş Durumu': getEmployeeStatusDisplayName(emp.workInfo?.workStatus) || '',
            'İşe Başlama': formatTurkishDate(emp.workInfo?.startDate),
            'Sözleşme Bitiş': formatTurkishDate(emp.workInfo?.contractEndDate),
            'Maaş': formatCurrency(emp.workInfo?.salary)
        }));

        downloadCSV(csvData, filename);
    } catch (error) {
        console.error('downloadEmployeeCSV error:', error);
        throw error;
    }
};

// ============================
// HOLIDAY API FUNCTIONS
// ============================

// Get holidays by year
export const getHolidaysByYear = async (year) => {
    try {
        const response = await api.get(`/holidays/${year}`);
        return response.data;
    } catch (error) {
        console.error('getHolidaysByYear error:', error);
        throw error;
    }
};

// Calculate working days between dates  
export const calculateWorkingDaysAPI = async (startDate, endDate) => {
    try {
        const response = await api.post('/holidays/calculate-working-days', {
            startDate,
            endDate
        });
        return response.data;
    } catch (error) {
        console.error('calculateWorkingDaysAPI error:', error);
        throw error;
    }
};

// Create holiday (admin only)
export const createHoliday = async (holidayData) => {
    try {
        const response = await api.post('/holidays', holidayData);
        return response.data;
    } catch (error) {
        console.error('createHoliday error:', error);
        throw error;
    }
};

// Get working days preview
export const getWorkingDaysPreview = async (startDate, endDate) => {
    try {
        const response = await api.get('/holidays/preview', {
            params: { startDate, endDate }
        });
        return response.data;
    } catch (error) {
        console.error('getWorkingDaysPreview error:', error);
        throw error;
    }
};

// Update holiday (admin only)
export const updateHoliday = async (holidayId, holidayData) => {
    try {
        const response = await api.put(`/holidays/${holidayId}`, holidayData);
        return response.data;
    } catch (error) {
        console.error('updateHoliday error:', error);
        throw error;
    }
};

// Delete holiday (admin only)
export const deleteHoliday = async (holidayId) => {
    try {
        const response = await api.delete(`/holidays/${holidayId}`);
        return response.data;
    } catch (error) {
        console.error('deleteHoliday error:', error);
        throw error;
    }
};